import React from "react";
import { Group } from "@mantine/core";
import { useFormContext } from "react-hook-form";
import RHFRadioGroup from "../../../../../../components/form/RHFRadioGroup";
import RHFNumberInput from "../../../../../../components/form/RHFNumberInput";
import { ReactComponent as AttentionCircleRed } from "../../../../../../assets/Attention Circle Red.svg";

const ExpensesReimbursement = ({ setActive, setTemporaryOpened }) => {
  const { watch, trigger, setValue } = useFormContext();

  const type_of_claim = watch("type_of_claim");
  const exp_reimbursement = watch("exp_reimbursement");

  const handleBack = () => {
    // If original claim was cancelled, step 4 (Actual flights taken) was skipped
    if (type_of_claim === "cancelled") {
      setActive((c) => c - 2);
    } else {
      setActive((c) => c - 1);
    }
  };

  const handleNext = async () => {
    if (exp_reimbursement === "yes") {
      const isValid = await trigger(["exp_reimbursement", "exp_reimbursement_amount"]);
      if (!isValid) return;
    } else {
      const isValid = await trigger(["exp_reimbursement"]);
      if (!isValid) return;
    }

    setActive((c) => c + 1);
  };

  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Claim for expenses reimbursement
        </h3>
      </div>

      <div >
        <h4 className="stepper-sub-header" style={{ marginBottom: "15px" }}>
          Do you want to claim for expenses reimbursement?
          <span style={{ color: "#de8385" }}> *</span>
        </h4>

        <Group mb="sm" align="center">
          <RHFRadioGroup
            name="exp_reimbursement"
            orientation="horizontal"

            rules={{ required: "Please select an option" }}
            onValueChange={(val) => {
              if (val === "no") {
                setValue("exp_reimbursement_amount", "");
              }
            }}
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
          />
        </Group>

        {exp_reimbursement === "yes" && (
          <div style={{ marginTop: "25px" }}>
            <h4
              className="stepper-sub-header"
              style={{ marginBottom: "10px", fontSize: "16px", fontWeight: 500 }}
            >
              Please enter the total Dollar amount you are claiming
              <span style={{ color: "#de8385" }}> *</span>
            </h4>

            <div style={{ maxWidth: "360px" }}>
              <RHFNumberInput
                name="exp_reimbursement_amount"
                allowDecimal={true}
                placeholder="0.00"
                leftSection={
                  <span style={{ color: "#7B8287", fontWeight: 600, fontSize: "15px" }}>
                    $
                  </span>
                }
                rules={{ required: 'Please enter the total Dollar amount you are claiming' }}
              />
            </div>

            {/* <div
              className="stepper-waring-container"
              style={{
                marginTop: "25px",
                padding: "16px 20px",
                backgroundColor: "#F7FAFC",
                border: "1px solid #D9E4EC",
                borderRadius: "12px",
                display: "flex",
                gap: "12px",
                alignItems: "flex-start",
              }}
            >
              <AttentionCircleRed
                style={{
                  flexShrink: 0,
                  marginTop: "3px",
                  width: "22px",
                  height: "22px",
                }}
              />
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <p
                  className="stepper-waring"
                  style={{
                    margin: 0,
                    color: "#314064",
                    fontSize: "15px",
                    lineHeight: "22px",
                    fontWeight: 500,
                  }}
                >
                  Please make sure to upload all supporting receipts in the next page under{" "}
                  <strong>“Additional Uploads”</strong>.
                </p>
                <p
                  className="stepper-waring"
                  style={{
                    margin: 0,
                    color: "#D04244",
                    fontWeight: 700,
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                >
                  Claims without proper supporting receipts will NOT be processed.
                </p>
              </div>
            </div> */}
          </div>
        )}
      </div>

      <div className="stepper-btn-wrapper" style={{ marginTop: "40px" }}>
        <button
          className="secondary-btn new-back-btn"
          type="button"
          onClick={handleBack}
        >
          Back
        </button>

        <div className="add-btn-wrapper">
          <button
            className="secondary-btn"
            type="button"
            onClick={() => setTemporaryOpened(true)}
          >
            Temporary Save
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpensesReimbursement;
